import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const plexApi = "Plex API";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callPlexOpenApi,
  category: NodeTypeCategory.services,
  label: plexApi,
  size: NodeSize.Small,
  controlInputs: [{ name: "call" }],
  controlOutputs: [{ name: "completed" }],
  dataInputs: [],
  documentDataInputListName: "inputs",
  dataOutputs: [],
  documentDataOutputList: "results",
  nodeConfigProperties: [
    {
      name: "plexOpenApiId",
      label: "Operation",
      propertyType: NodeConfigPropertyType.PlexOpenApi,
      schemaSourceSystemType: DocumentSchemaSource.plexOpenApi,
      schemaSystem: { createIo: true }
    },
    {
      name: "plexOpenApiName",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: DocumentSchemaSource.plexOpenApi
    },
    {
      name: "inputs",
      sectionName: "Input",
      propertyType: NodeConfigPropertyType.EnabledInputs
    },
    {
      name: "results",
      sectionName: "results",
      propertyType: NodeConfigPropertyType.EnabledOutputs
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallPlexOpenApiNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = data.nodeProperties.plexOpenApiName ?? plexApi;
  data.nodeProperties.label = label;
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
